export const countVacancies = async (type: 'fysio' | 'fit'): Promise<number> => {
	return queryCollection('vacancies').where('organization', '=', type).count() ?? 0;
};
